<div class="stage-title">Stages of adoption</div>

<div class="container">
  <div class="stages">
    <div class="stage">
      <div class="box"></div>
      <div class="line"></div>
      <div class="label">Awareness</div>
    </div>
    <div class="stage stage-top">
      <div class="box"></div>
      <div class="line"></div>
      <div class="label">Interest</div>
    </div>
    <div class="stage">
      <div class="box"></div>
      <div class="line"></div>
      <div class="label">Experimentation</div>
    </div>
    <div class="stage stage-top">
      <div class="box"></div>
      <div class="line"></div>
      <div class="label">Adoption</div>
    </div>
  </div>
</div>
